import { render } from "./equipment-terminals.vue?vue&type=template&id=65b5b458&scoped=true"
import script from "./equipment-terminals.vue?vue&type=script&lang=js"
export * from "./equipment-terminals.vue?vue&type=script&lang=js"

import "./equipment-terminals.vue?vue&type=style&index=0&id=65b5b458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b5b458"]])

export default __exports__